import getDefaultWorkerCount from "./getDefaultWorkerCount"
import resolveWebWorkerJob from "./resolveWebWorkerJob"

export const workerList: Array<Worker> = []

const defaultWorkerCount = getDefaultWorkerCount()

// console.log('defaultWorkerCount', defaultWorkerCount)

for (let i = 0; i < defaultWorkerCount; i++) {
  const worker = new Worker(new URL('./generic.worker.ts', import.meta.url), { type: 'module' })
  workerList.push(worker)

  worker.onmessage = onMessage

  // setTimeout(() => {
  //   const workerJobsList = getWebWorkerJobsList(worker)
  //   console.log('workerJobsList', workerJobsList.length)
  // }, 10000)
}

function onMessage(
  this: Worker,
  event: MessageEvent
): void {
  if (event.data.j) {
    resolveWebWorkerJob(this, event.data)
  }
}